import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import authReducer, { authSlice } from './auth/slices';
import balanceSlice from './balance/slice';
import reportsSlice from './reports/slice';
import transactionsSlice from './transactions/slice';
import summarySlice from './summary/slice';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};
const authPersistReducer = persistReducer(authPersistConfig, authReducer);

const middleware = [
  ...getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
  // authSlice.middleware,
];

const store = configureStore({
  reducer: {
    auth: authPersistReducer,
    balance: balanceSlice,
    reports: reportsSlice,

    transactions: transactionsSlice,

    summary: summarySlice,
  },
  middleware,
  devTools: process.env.NODE_ENV === 'development',
});

const persistor = persistStore(store);

export { store, persistor };
